import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import envEndpoints from "./env";

function createAxios(auth, baseURL, customHeader) {
    const headers = {};

    function getAuthHeader() {
        return `${window.localStorage.getItem("token")}`;
    }

    function deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    function readCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    let outletId = window.localStorage.getItem("outletId");
    if (readCookie("outletId")) {
        outletId = readCookie("outletId")
    }

    headers["X-Client"] = "consumer";
    headers["X-TrackingId"] = uuidv4();
    headers["HeaderRoute"] = "v2";
    headers["APIVersion"] = 7.7;
    if (sessionStorage.getItem("onboarding_source") == "partner_web") {
        headers["AppType"] = "partner_web";
    } else {
        headers["AppType"] = window.outerWidth < 992 ? "mweb" : "web";
    }
    if (outletId !== null) {
        headers["X-OutletId"] = outletId;
    }

    // ====== temp ========
    // headers["x-envoy-upstream-rq-timeout-ms"] = 40000;
    if (auth) {
        let token = getAuthHeader()
        if (readCookie("token")) {
            token = readCookie("token")
        }
        headers["Authorization"] = token;
    }

    if (customHeader) {
        for (let i in customHeader) {
            headers[i] = customHeader[i];
        }
    }

    const instance = axios.create({
        baseURL,
        // withCredentials: true,
        headers,
    });

    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // Exclude s3 urls with 403 code
            const isS3Url =
                error.config &&
                /(s3-|s3\.)?(.*)\.amazonaws\.com/.test(error.config.url);
            if (!isS3Url && [401, 403, 410].includes(error.response.status)) {
                alert("Session Expired! Please login again");

                // redirect to sign in page
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("outletId");
                deleteCookie("token")
                deleteCookie("outletId")
                window.location.href = "/signin";
                // window.location.href = "/signout";
            }
            // if (error.response.status === 417) {
            //   instance.request(error.config);
            // }
            return Promise.reject(error);
        }
    );
    return instance;
}

function getAxios(
    auth = false,
    baseUrl = envEndpoints.urls.hyperpureHost,
    customHeader = null
) {
    return createAxios(auth, baseUrl, customHeader);
}

export default getAxios;